import CommunicationHandler from './CommunicationHandler';
export var commsHandler = new CommunicationHandler();